import { api } from "../api";

export const getAllCondominios = function (callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = "/condominio";

    api
        .get(URL)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getAllcondominios " + error);
        });
};

export const getCondominioById = function (condominioId, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condominio/${condominioId}`;

    api
        .get(URL)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getCondominioById " + error);
        });
};

export const saveCondominio = function (data, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condominio`;

    api
        .post(URL, data)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. saveCondominio " + error);
        });
};

export const deleteCondominio = function (condominioId, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condominio/${condominioId}`;

    api
        .delete(URL)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. deleteCondominio " + error);
        });
};

export const updateCondominio = function (condominioId, data, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condominio/${condominioId}`;

    api
        .put(URL, data)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. updateCondominio " + error);
        });
};

export const saveCondominioLockers = function (data, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condominio/lockers`;

    api
        .post(URL, data)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. saveCondominioLockers " + error);
        });
};

export const getCondominioLockers = function (condominioId, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condominio/lockers/${condominioId}`;

    api
        .get(URL)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getCondominioLockers " + error);
        });
};

export const deleteCondominioLockers = function (data, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condominios/lockers`;

    api
        .put(URL, data)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. deleteCondominioLockers " + error);
        });
};

export const getLockerRelated = function (lockerId, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/condominio/locker/${lockerId}`;

    api
        .get(URL)
        .then((response) => {
            callback([response.data.data]);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getCondominioLockers " + error);
        });
};